module.exports = __webpack_public_path__ + "img/antes_despues_192.3e93d5d7.png";